<ng-form name="form" novalidate *ngIf="show">
  <div style="padding:8px 8px;max-width:400px" class="fieldlist">
    <div id="tabContentSz">
      <!--<div class="md-toolbar" style="height:48px;background-color: #3f51b5">
        <!--<img src="../images/Logos/attribute logo v5.png" class="md-avatar" alt="no image" style="height:30px;width:117px;padding-top:9px;margin:auto;margin-left:12px">-->
      <!--</div>-->
        <div class="pds-form-field">
            <label class="pds-form-label" for="userName">Email</label>
            <dx-text-box class="pds-form-value" id="UserName" type="email" [(ngModel)]="userModel.userName" name="userName"></dx-text-box>
        </div>
        <div class="pds-form-field">
            <label class="pds-form-label" for="password">Password</label>
            <dx-text-box class="pds-form-value" id="Password" mode="password" [(ngModel)]="userModel.password" name="password"></dx-text-box>
        </div>

        <div class="md-block padding-right-5" flex="auto">
            <div>
            <input type="checkbox" id="rememberMe" [(ngModel)]="userModel.rememberMe" name="rememberMe" />
            <label class="attribute-label" for="rememberMe">Remember Me</label>
            </div>
        </div>

        <div class="md-block margin-top-10" flex="auto" (click)="login()">
            <dx-button text="Login"></dx-button>
        </div>
        <div class="form-group">
            <p>
                <a [routerLink]="['/account/forgot-password']" href="#">Forgot your password?</a>
            </p>
        </div>
    </div>
    </div>
</ng-form>